<template>
  <div class="back-container">
    <div class="" style="height: 60px;line-height: 60px">
        <span @click="$router.back(-1)" style="float: left;margin-left: 40px;cursor: pointer;">
         <i class="el-icon-back"></i>
          返回
        </span>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: "Back"
}
</script>

<style scoped>
/deep/ .el-divider--horizontal{
  margin: 0;
}
  .back-container {
    position: sticky;
    top: 0;
    z-index: 998;
    background: #fff;
  }
</style>
